export enum ButtonVariant {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  PALE_PINKISH = 'pale-pinkish',
}
